import useChatsItems from '@src/hooks/useChatsItems';
import useChatsItemsSize from '@src/hooks/useChatsItemsSize';
import { increaseOffsetChatsBot } from '@src/reducers/chats';
import { RefObject, useRef } from 'react';
import { useDispatch } from 'react-redux';
import ChatListItems from '../ChatListItems';
import './ChatsBot.css';

const ChatsBot: React.FC<{ chatsSearchRef: RefObject<HTMLDivElement> }> = ({
  chatsSearchRef,
}) => {
  const dispatch = useDispatch();
  const chatsBotRef = useRef<HTMLDivElement>(null);

  const chatsItemsSize = useChatsItemsSize(chatsBotRef, chatsSearchRef);
  const chatsBotItems = useChatsItems();

  return (
    <div className="ChatsBotBox" ref={chatsBotRef}>
      <ChatListItems
        key="CHATS_BOT"
        items={chatsBotItems}
        height={chatsItemsSize}
        onScrollBottom={() => dispatch(increaseOffsetChatsBot())}
      />
    </div>
  );
};

export default ChatsBot;
